import { useMutation } from 'react-query';
import api from 'src/services/api';

export const useSendFeedback = () => useMutation((data) => api.post('/internal/feedback', data));
